import { render } from "./JsonEditor.vue?vue&type=template&id=6eeabb06"
import script from "./JsonEditor.vue?vue&type=script&lang=js"
export * from "./JsonEditor.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mohamed/Projects/mantiq/code/wp-content/plugins/mantiq/editor/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__